import { z } from "zod";

import { DISCRIMINATOR } from "./common";

type Discriminator = typeof DISCRIMINATOR;

function zAggregated<
  Options extends readonly [
    z.ZodDiscriminatedUnionOption<Discriminator>,
    ...z.ZodDiscriminatedUnionOption<Discriminator>[],
  ],
>(options: Options) {
  return z.discriminatedUnion(DISCRIMINATOR, options);
}

export { zAggregated };
